import axiosInstance from './apiinterseptor';
import { getApiErrorMessage } from '../utils/apiError';

export interface TeamMember {
  _id: string;
  name: string;
  designation: string;
  linkedinUrl: string;
  description: string;
  photoUrl: string;
  position: number;
  createdAt: string;
  updatedAt: string;
}

export interface TeamMemberInput {
  name: string;
  designation: string;
  linkedinUrl: string;
  description: string;
  photoUrl: string;
}

interface TeamListResponse {
  success: boolean;
  data: {
    members: TeamMember[];
  };
}

interface TeamResponse {
  success: boolean;
  message?: string;
  data: {
    member: TeamMember;
  };
}

export const getTeamMembers = async (): Promise<TeamMember[]> => {
  try {
    const response = await axiosInstance.get<TeamListResponse>('/teams');
    return response.data.data.members;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load team members'));
  }
};

export const createTeamMember = async (payload: TeamMemberInput): Promise<TeamMember> => {
  try {
    const response = await axiosInstance.post<TeamResponse>('/teams', payload);
    return response.data.data.member;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to add team member'));
  }
};

export const updateTeamMember = async (
  id: string,
  payload: TeamMemberInput
): Promise<TeamMember> => {
  try {
    const response = await axiosInstance.put<TeamResponse>(`/teams/${id}`, payload);
    return response.data.data.member;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update team member'));
  }
};

export const reorderTeamMembers = async (ids: string[]): Promise<TeamMember[]> => {
  try {
    const response = await axiosInstance.put<TeamListResponse>('/teams/order', { ids });
    return response.data.data.members;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update team order'));
  }
};

export const deleteTeamMember = async (id: string): Promise<void> => {
  try {
    await axiosInstance.delete(`/teams/${id}`);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete team member'));
  }
};
